__turbopack_context__.v({
  "btnClose": "NoticePopup-module-scss-module__Id2QEq__btnClose",
  "dot": "NoticePopup-module-scss-module__Id2QEq__dot",
  "dotActive": "NoticePopup-module-scss-module__Id2QEq__dotActive",
  "dots": "NoticePopup-module-scss-module__Id2QEq__dots",
  "footer": "NoticePopup-module-scss-module__Id2QEq__footer",
  "image": "NoticePopup-module-scss-module__Id2QEq__image",
  "imageArea": "NoticePopup-module-scss-module__Id2QEq__imageArea",
  "overlay": "NoticePopup-module-scss-module__Id2QEq__overlay",
  "popup": "NoticePopup-module-scss-module__Id2QEq__popup",
  "title": "NoticePopup-module-scss-module__Id2QEq__title",
});
